module.exports = __webpack_public_path__ + "static/media/Michelin_C_H_WhiteBG_RGB_0621-01.a168d73d.svg";